import * as utils from './utils.js';
import i18n from './i18n/i18n.js';
import { generateReportPDF } from './pdfUtils.js';
import { formatReportTimelineDate } from './components/reports/reportHelpers.js';

function buildItemColumns(item, role) {
  const isBroker = role === 'broker';
  const companyName = item.company_name || item.company?.name || item.company?.id || '-';
  const columns = [];

  if (isBroker && item.partner) {
    columns.push({
      header: i18n.t('reports.partnerName'),
      data: item.partner?.name || item.partner?.id || '-',
      cellStyle: { cellWidth: 20 }
    });
  }

  columns.push(
    { header: i18n.t('quoteInfo.id'), data: item.rfq_id || '-',  cellStyle: { /* stretch */ }},
    { header: i18n.t('quoteInfo.clientName'), data: companyName, cellStyle: { cellWidth: 18 }},
    { header: i18n.t('quoteInfo.dealTime'), data: formatReportTimelineDate(item.rfq_deal_time), cellStyle: { cellWidth: 24 } },
    { header: i18n.t('quoteInfo.ccy'), data: item.rfq_ccy || '-', cellStyle: { cellWidth: 12 } },
    { header: i18n.t('quoteInfo.amountCcy'), data: utils.formatPrice(item.rfq_amount) || '-', cellStyle: { cellWidth: 18 } },
    { header: i18n.t('quoteInfo.clientRate'), data: item.rfq_final_rate != null ? Number(item.rfq_final_rate).toFixed(4) : '-', cellStyle: { cellWidth: 12 } },
    { header: i18n.t('quoteInfo.volumeCcyBrl'), data: item.volume_brl != null && Number.isFinite(Number(item.volume_brl)) ? 'R$ ' + utils.formatBRLPretty(Number(item.volume_brl)) : '-', cellStyle: { cellWidth: 18 } },
    { header: i18n.t('quoteInfo.side'), data: item.rfq_side || '-', cellStyle: { cellWidth: 10 } },
    { header: i18n.t('quoteInfo.settlement'), data: item.rfq_security !== 'FXNDF' ? item.rfq_spotsett?.toUpperCase() : '-', cellStyle: { cellWidth: 16 } },
    { header: i18n.t('quoteInfo.status'), data: item.rfq_status || '-', cellStyle: { cellWidth: 17 } }
  );

  return columns;
}

export async function generateRfqsReportPDF(reportsData) {
  await generateReportPDF({ reportsData, buildItemColumns, fileName: 'report_fx' });
}
